import image1 from '../../images/anli1.jpg';
import image2 from '../../images/anli2.jpg';
import image3 from '../../images/anli3.jpg';
import image4 from '../../images/anli4.jpg';
import image5 from '../../images/anli5.jpg';
import image6 from '../../images/anli6.jpg';


export const portfolioData = [
	image1,
	image2,
	image3,
	image4,
	image5,
	image6,
]



// WEBPACK FOOTER //
// ./src/components/portfolio/portfolio-data.js